import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';

const Legal = () => {
  useDocTitle('Legal');
  return (
    <>
      <NavBar />
      <div className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-blue-900 mb-4">Legal</h1>
          <p className="text-gray-700">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vel libero vel augue
            vehicula ultricies. Nullam facilisis, velit sit amet viverra tempor, justo augue
            volutpat odio, sed facilisis dui enim at metus.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Legal;
